import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
);

export const options = {
	responsive: true,
	interaction: {
		mode: 'index',
		intersect: false,
	},
	stacked: false,
	plugins: {
		legend: {
			display: false,
		},
		title: {
			display: true,
			// text: 'Chart.js Line Chart - Multi Axis',
		},
	},
	scales: {
		y: {
			type: 'linear',
			display: true,
			position: 'left',
			title: {
				display: true,
				text: 'Total Value ($K)',
				font: {
					size: 14,
					weight: '500',
					family: "'Inter', sans-serif",
				},
				color: 'rgba(32, 32, 32, 0.8)',
			},
		},
		y1: {
			type: 'linear',
			display: true,
			position: 'right',
			grid: {
				drawOnChartArea: false,
			},
			title: {
				display: true,
				text: 'Total Count',
				font: {
					size: 14,
					weight: '500',
					family: "'Inter', sans-serif",
				},
				color: 'rgba(32, 32, 32, 0.8)',
			},
		},
	},
};

const labels = ['2017','2018','2019', '2020', '2021', '2022', '2023', '2024', '2025'];

export const data = {
	labels,
	datasets: [
		{
			label: 'Total Value ($K)',
			data: [0.7,15.2,32.6,18.8,21.5,27.6,28.4,55.3,113.2],
			borderColor: 'rgb(97, 170, 30)',
			backgroundColor: 'rgba(97, 170, 30, 0.5)',
			yAxisID: 'y',
			tension: 0.3,
		},
		{
			label: 'Total Count',
			data: [5,112,317,289,256,353,305,418,723],
			borderColor: 'rgb(22, 145, 145)',
			backgroundColor: 'rgba(22, 145, 145, 0.5)',
			yAxisID: 'y1',
			tension: 0.3,
		},
	],
};

export function ReclaimDashboardChart() {
	return <Line options={options} data={data} />;
}
export default ReclaimDashboardChart;
